import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import LanguageSelector from './LanguageSelector';

const Header = ({ transparent = false }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <nav 
      className={`site-header ${transparent ? 'relative z-40' : 'relative'}`}
      style={{ 
        backgroundColor: transparent ? '#00000050' : 'var(--color-dark)',
        borderBottom: transparent ? '1px solid rgba(255,255,255,0.1)' : 'none',
        padding: '10px 0px',
        marginBottom: '30px'
      }}
    >
      <div className="container mx-auto px-4 py-3 sm:py-4 flex justify-between items-center">
        {/* Logo Only - Left Side */}
        <div 
          className="flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => navigate('/')}
        >
          {theme.logo_url ? (
            <img src={theme.logo_url} alt="Logo" className="h-8 sm:h-10 md:h-12 w-auto" />
          ) : (
            <div 
              className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: 'var(--color-primary)' }}
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
          )}
        </div>

        {/* Language Selector - Right Side */}
        <div className="flex-shrink-0">
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
};

export default Header;
